
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
// Locale
import messages from '../../../locale/messages';

//Image
import noImage from '/public/SiteImages/noResultImage.svg';
import s from './NoResults.css';

class NoResults extends React.Component {

  render() {
    return (
      <div className={s.root}>
        <img src={noImage} className='noResultImg' />
        <div className={s.noHeading}>
          <FormattedMessage {...messages.noResultsTitle} />
        </div>
        <div className={cx(s.noSubHeading)}>
          <FormattedMessage {...messages.noResultsSubTitle} />
        </div>
        <div className={cx(s.noSubHeading)}>
          <FormattedMessage {...messages.noResultsTerms1} />
        </div>

      </div>
    );
  }
}

export default injectIntl(withStyles(s)(NoResults));